import { BEAT_EVERY_MS, heartbeatFor, shouldBeat } from "../../server/rules/usage";
import { requestHeaders } from "../ui/dom";

// App activity (brief 1A-7): once a minute, while the tab is visible and the person used it in
// the last minute, the shell tells the server which area they're in. Only that the person did
// something is noted (the time), never what: no keys, no text, nothing that was shown. The server
// counts a heartbeat as activity for the idle sign-out (brief 1E-19c), so typing with nothing sent
// yet keeps the session.

const INPUT = ["keydown", "pointerdown", "mousemove", "wheel", "touchstart", "scroll"] as const;

export function startHeartbeat() {
  let lastInputAt: number | null = Date.now();
  const used = () => {
    lastInputAt = Date.now();
  };
  for (const type of INPUT) document.addEventListener(type, used, { passive: true, capture: true });
  setInterval(() => {
    const visible = document.visibilityState === "visible";
    if (!shouldBeat({ visible, lastInputAt, now: Date.now() })) return;
    void fetch("/api/usage/heartbeat", {
      method: "POST",
      cache: "no-store",
      headers: { ...requestHeaders(), "content-type": "application/json" },
      body: JSON.stringify(heartbeatFor(location.pathname)),
    }).catch(() => undefined);
  }, BEAT_EVERY_MS);
}
